import React from 'react'
import { CCard, CCardBody } from '@coreui/react'

// Actualizaciones — ruta /superadmin/actualizaciones.
// Placeholder: sin backend real todavía (no se inventa funcionalidad).
const SuperAdminActualizacionesPage: React.FC = () => (
  <CCard className="shadow-sm">
    <CCardBody className="text-center py-5">
      <div className="fs-5 mb-2">Actualizaciones</div>
      <div className="text-body-secondary">Disponible próximamente</div>
    </CCardBody>
  </CCard>
)

export default SuperAdminActualizacionesPage
